export default {
    en: {
        longDateFormat: {
            LT: 'h:mm A',
            LTS: 'h:mm:ss A',
            L: 'MM/DD/YYYY',
            l: 'MM/DD/YYYY',
            LL: 'MMMM D',
            ll: 'MMM D, YYYY',
            LLL: 'MMMM D, LT',
            lll: 'MMM DD, hhA',
            LLLL: 'dddd, MMMM Do, YYYY LT',
            llll: 'ddd, MMM D, YYYY LT',
        },
    },
    ja: {
        longDateFormat: {
            LT: 'HH時mm分',
            LTS: 'HH時mm分ss秒',
            L: 'YYYY年M月D日',
            l: 'YYYY年M月D日',
            LL: 'M月D日',
            ll: 'YYYY年M月D日',
            LLL: 'M月D日 LT',
            lll: 'M月D日 HH時',
            LLLL: 'YYYY年M月D日 dddd LT',
            llll: 'YYYY年M月D日 (ddd) LT',
        },
    },
    de: {
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD.MM.YYYY',
            l: 'DD.MM.YYYY',
            LL: 'D. MMMM',
            ll: 'D. MMM YYYY',
            LLL: 'D. MMMM LT',
            lll: 'D. MMM HH:00',
            LLLL: 'dddd, D. MMMM YYYY LT',
            llll: 'ddd, D. MMM YYYY LT',
        },
    },
    fr: {
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD/MM/YYYY',
            l: 'DD/MM/YYYY',
            LL: 'D MMMM',
            ll: 'D MMM YYYY',
            LLL: 'D MMMM LT',
            lll: 'D MMM HH:00',
            LLLL: 'dddd D MMMM YYYY LT',
            llll: 'ddd D MMM YYYY LT',
        },
    },
} as {
    [key: string]: {
            longDateFormat: {
                LT: string,
                LTS: string,
                L: string,
                l: string,
                LL: string,
                ll: string,
                LLL: string,
                lll: string,
                LLLL: string,
                llll: string,
        },
    },
};
